import { buildProviderByType } from '../utils';
import { type } from './const';

export default buildProviderByType(type);
